import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CustomPrintPanZoomPhoto from '../components/CustomPrintPanZoomPhoto';
import { getIdentityFullName } from '../../../../util/identity';

const propTypes = {
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photos_no: PropTypes.number.isRequired,
    custom_print: PropTypes.shape({
      id: PropTypes.string.isRequired,
      background_image: PropTypes.shape({
        url: PropTypes.string,
      }),
      account: PropTypes.shape({
        logo_image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  config: PropTypes.shape({
    caption: PropTypes.string,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
        position: PropTypes.number.isRequired,
        cropbox: PropTypes.object,
      }),
    ),
  }).isRequired,
  onTriggerPhotoSelection: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
};

const MemoryMateConfiguratorTemplate = ({
  albumCustomPrint,
  config,
  onTriggerPhotoSelection,
  onPhotoCropboxSet,
}) => {
  const positions = Array.from({ length: albumCustomPrint.photos_no });
  const backgroundImageUrl =
    albumCustomPrint.custom_print.background_image?.url;
  const identityFullName = getIdentityFullName(albumCustomPrint.identity);

  return (
    <div className="custom-print-memory-mate">
      {!!backgroundImageUrl && (
        <img
          src={backgroundImageUrl}
          alt=""
          className="custom-print-memory-mate-bg"
        />
      )}

      {positions.map((_, index) => {
        const selectedPhoto = config.photos.find(
          photo => photo.position === index,
        );

        return (
          <Fragment key={index}>
            <CustomPrintPanZoomPhoto
              className="custom-print-memory-mate-photo"
              key={index}
              position={index}
              photo={selectedPhoto?.photo}
              onEdit={onTriggerPhotoSelection}
              onPhotoCropboxSet={onPhotoCropboxSet}
            />
            {index === 0 && (
              <span className="custom-print-memory-mate-main-photo-note">
                Single Photo
              </span>
            )}
            {index === 1 && (
              <span className="custom-print-memory-mate-team-photo-note">
                Group Photo
              </span>
            )}
          </Fragment>
        );
      })}

      {identityFullName && (
        <span className="custom-print-memory-mate-identity-name">
          {identityFullName}
        </span>
      )}
    </div>
  );
};

MemoryMateConfiguratorTemplate.propTypes = propTypes;

export default MemoryMateConfiguratorTemplate;
